import { isMobile } from 'utils/is-mobile';
import { Skeleton } from 'newcomponents/UI/Skeleton';

export const BetOnEventsSkeleton = () => {
  return (
    <Skeleton.Button
      active
      style={{ width: '100%', height: isMobile() ? '222px' : '198px' }}
      applyElementStyle={false}
    />
  );
};
